// extracted by mini-css-extract-plugin
export default {"searchWidget":"SearchWidget_searchWidget__81gx9","searchWidgetIcon":"SearchWidget_searchWidgetIcon__dXrrZ","searchWidgetInput":"SearchWidget_searchWidgetInput__esAeD"};